import UploadComponent from 'components/uploadComponent/uploadComponent';
import { observer } from 'mobx-react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import classes from './UploadExcel.module.scss';
import { useUploadExcelModal } from './UploadExcel.logic';

const UploadExcelModal = observer(({ onClose }: { onClose: () => void }) => {
  const {
    isUploadingFile,
    uploadFileError,
    uploadColumnErrors,
    handleDownloadTemplate,
    handleUploadFile,
    handleClose,
  } = useUploadExcelModal(onClose);

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      header="Upload Unconstrained Forecast"
      visible
      style={{ width: '30vw', minWidth: '420px' }}
      onHide={handleClose}
    >
      <div style={{ position: 'relative' }}>
        <UploadComponent
          toggleVisibility={handleClose}
          handleDownloadTemplate={handleDownloadTemplate}
          handleUploadFile={handleUploadFile}
          isFileUploading={isUploadingFile}
        />

        {isUploadingFile && (
          <div className={classes.validationLoader}>
            <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
            <span>Validating data, please wait…</span>
          </div>
        )}

        {uploadFileError && (
          <div className={classes.uploadError}>
            <span>{uploadFileError}</span>
            {uploadColumnErrors.length > 0 && (
              <ul className={classes.uploadErrorList}>
                {uploadColumnErrors.map((err, i) => (
                  <li key={i}>{err}</li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </Dialog>
  );
});

export default UploadExcelModal;
